module.exports = __webpack_public_path__ + "../resources/img/ic_re_no2_p2_line_wh.92cd4191.svg";